import { length, map } from 'ramda';

import { clear } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { toBooleanFromProp } from '../../fields/boolean';
import { toTextFromProp } from '../../fields/text';
import { keyFigure } from '../../partials/key-figure';

export const deprecatedKeyFigureSlice = ({ primary }) => {
  const normalized = keyFigure(primary);
  if (normalized) {
    return clear({
      type: CommonSliceType.KEY_FIGURE,
      keyFigures: [normalized],
    });
  }
};

export const deprecatedKeyFigure3Slice = ({ items = [] }) => {
  const normalized = map(keyFigure, items);

  if (length(normalized)) {
    return {
      type: CommonSliceType.KEY_FIGURE,
      keyFigures: normalized,
    };
  }
};

export const keyFiguresSlice = (prismicData) => {
  const normalized = prismicData?.items
    ?.map((data) => {
      const figure = toTextFromProp('number', data);

      if (!figure) {
        return undefined;
      }

      return {
        figure,
        animateFigure: toBooleanFromProp('animate', data, {
          defaultValue: true,
        }),
        title: toTextFromProp('description_1', data),
        desc: toTextFromProp('description_2', data),
      };
    })
    ?.filter(Boolean);

  let res;
  if (length(normalized)) {
    res = {
      type: CommonSliceType.KEY_FIGURE,
      keyFigures: normalized,
    };
  }

  return res;
};
